{
  "name": "cei-admin-panel-frontend",
  "version": "1.26.0-beta.31",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "dev": "npm run generate:api:local && npm run start:clean",
    "prebuild": "node tools/prebuild-openapi.mjs",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "yalc:link": "yalc add @cei-ufg/ngx-arquitetura-cei-commons @cei-ufg/ngx-arquitetura-cei-frontend @cei-ufg/ngx-cei-sso-client @cei-ufg/ngx-cei-seguranca",
    "yalc:update": "yalc update",
    "start:clean": "sh -c 'if [ -n \"${PORT:-}\" ]; then ng cache clean && ng serve --port \"${PORT}\" \"$@\"; elif [ -n \"${npm_config_port:-}\" ]; then ng cache clean && ng serve --port \"${npm_config_port}\" \"$@\"; else ng cache clean && ng serve \"$@\"; fi' --",
    "sc": "sh -c 'if [ -f yalc.lock ]; then yalc update; fi && npm run start:clean -- \"$@\"' --",
    "serve:ssr:cei-admin-panel-frontend": "node dist/cei-admin-panel-frontend/server/server.mjs",
    "e2e": "npm --prefix e2e run test",
    "e2e:native": "npm --prefix e2e run test:native",
    "e2e:install": "npm --prefix e2e install --no-fund --no-audit && npm --prefix e2e run install:browsers",
    "generate:api": "node tools/openapi/generate-api.mjs --spec-url http://localhost:8000/swagger/schema/?format=json --save-spec tools/openapi/specs/admin-api.json",
    "generate:api:local": "node tools/openapi/generate-api.mjs --skip-download"
  },
  "private": true,
  "engines": {
    "node": "^22.12.0 || >=24.0.0"
  },
  "dependencies": {
    "@angular/animations": "21.2.13",
    "@angular/cdk": "21.2.11",
    "@angular/common": "21.2.13",
    "@angular/compiler": "21.2.13",
    "@angular/core": "21.2.13",
    "@angular/forms": "21.2.13",
    "@angular/material": "21.2.11",
    "@angular/platform-browser": "21.2.13",
    "@angular/platform-server": "21.2.13",
    "@angular/router": "21.2.13",
    "@angular/ssr": "21.2.11",
    "@cei-ufg/ngx-arquitetura-cei-commons": "0.2.0-beta.1",
    "@cei-ufg/ngx-arquitetura-cei-frontend": "1.41.0-beta.39",
    "@cei-ufg/ngx-cei-seguranca": "0.2.0-beta.1",
    "@cei-ufg/ngx-cei-sso-client": "2.0.0-beta.1",
    "express": "^5.1.0",
    "ngx-mask": "^21.0.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "21.2.11",
    "@angular/cli": "21.2.11",
    "@angular/compiler-cli": "21.2.13",
    "@openapitools/openapi-generator-cli": "^2.30.2",
    "@semantic-release/changelog": "^6.0.3",
    "@semantic-release/commit-analyzer": "^13.0.1",
    "@semantic-release/exec": "^6.0.3",
    "@semantic-release/git": "^10.0.1",
    "@semantic-release/npm": "^12.0.2",
    "@semantic-release/release-notes-generator": "^14.0.3",
    "@types/express": "^5.0.1",
    "@types/node": "^20.17.19",
    "jsdom": "^28.0.0",
    "prettier": "^3.8.1",
    "semantic-release": "^24.2.7",
    "typescript": "~5.9.2",
    "vitest": "^4.0.8"
  }
}
